import client from './client'
import { Book, Sheet, PaginationApiResponse, Pagination } from '@/models'

export default {
  list: ( cd: string , search: { pagination: Pagination; filter?: {[key:string]: string | number} }) =>
    client
      .post<{
        questions: { question: string; type: 'txt' | 'lbl' }[]
        resultList: {
          columns: { name: string; label: string; field: string }[]
          rows: { [key: string]: string }[]
        }
        pagination: PaginationApiResponse
      }>(`get_book_result_list?cd=${cd}`, { search })
      .then(({ data }) => ({
        resultList: data.resultList,
        questions: data.questions,
        pagination: { ...data.pagination }
      })),

  get: (params: { cd: string }) =>
    client.get<{ book: Book; sheet: Sheet }>('get_sheet_data', { params }).then(({ data }) => data),

  set: (sheet: Sheet) => client.post('set_sheet_data', { form: { sheet } }).then(({ data }) => data),

  getAnswer: (params: { cd: string }) =>
    client.get<{ book: Book; sheet: Sheet }>('get_answer_data', { params }).then(({data}) => data),

  getAnswerResult: (params: { cd: string, isLoginFlg: boolean }) =>
    client.get<{ book: Book; sheet: Sheet }>('get_answer_data', { params }).then(({data}) => data),

  setConfirm: (confirm: {[key : string]: string}) => client.post('set_confirm_data', { form: { confirm } }).then(({data}) => data)
}
